import * as React from "react";
const SvgReadMoreThreeDots = props => <svg width={14} height={2} viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.75 1.5C7.02614 1.5 7.25 1.27614 7.25 1C7.25 0.723858 7.02614 0.5 6.75 0.5C6.47386 0.5 6.25 0.723858 6.25 1C6.25 1.27614 6.47386 1.5 6.75 1.5Z" fill="currentColor" stroke="currentColor" style={{
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeOpacity: 1
  }} strokeLinecap="round" strokeLinejoin="round" /><path d="M1 1.5C1.27614 1.5 1.5 1.27614 1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1C0.5 1.27614 0.723858 1.5 1 1.5Z" fill="currentColor" stroke="currentColor" style={{
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeOpacity: 1
  }} strokeLinecap="round" strokeLinejoin="round" /><path d="M12.5 1.5C12.7761 1.5 13 1.27614 13 1C13 0.723858 12.7761 0.5 12.5 0.5C12.2239 0.5 12 0.723858 12 1C12 1.27614 12.2239 1.5 12.5 1.5Z" fill="currentColor" stroke="currentColor" style={{
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeOpacity: 1
  }} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgReadMoreThreeDots;